export const TPS_RATE_MANAGEMENT_TYPES_ROUTE = 'locations.rateManagement.types'

export function isTpsIntegrated (location) {
  return !!(location && location.integration_system === 'tps')
}

export function isActiveLocationForRoute (location, routeLocationId) {
  return !!(location && location.id != null && String(location.id) === String(routeLocationId))
}

/** Avoid tab bar flash on refresh before locations.get completes. */
export function shouldShowRateManagementTabs (location, routeLocationId) {
  if (!isActiveLocationForRoute(location, routeLocationId)) {
    return false
  }
  return !isTpsIntegrated(location)
}

export function redirectTpsFromRateManagement (router, store, locationId) {
  const active = store.state.locations.active
  if (active && String(active.id) === String(locationId) && isTpsIntegrated(active)) {
    router.replace({ name: TPS_RATE_MANAGEMENT_TYPES_ROUTE, params: { id: locationId } })
    return true
  }
  return false
}

/** @returns {Promise<boolean>} false if redirected to Rate Types (TPS) */
export function fetchLocationAndRedirectTps (store, router, locationId) {
  if (redirectTpsFromRateManagement(router, store, locationId)) {
    return Promise.resolve(false)
  }
  return store.dispatch('locations.get', { id: locationId }).then(() => {
    if (redirectTpsFromRateManagement(router, store, locationId)) {
      return false
    }
    return true
  })
}
